import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import TopHeadScreen from "../../component/layout/tophead";
import SidebarScreen from "../../component/layout/sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import { LuEye } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import DataTable from "../../common/data-table";
import {
  appliedJobDelete,
  appliedJobDetails,
  appliedJobList,
} from "../../service/apis/auth.api";
import { showError } from "../../utils/Common";
import moment from "moment";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import AgentSidebarScreen from "../../component/layout/agent-sidebar";
import AgentTopHeadScreen from "../../component/layout/agent-header";
import { Alert } from "../../common/Alert/alert";
import Loader from "../../common/Loader/loader";
import _ from "lodash";
import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import { AppRoute } from "../../router/routerConstants";

const AppliedJobScreen = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [totalPages, setTotalPages] = useState(1);
  const { user } = useSelector((state: RootState) => state.authSlice);

  const [appliedJobsTableData, setAppliedJobsTableData] = useState([]);
  const [jobDetails, setAppliedJobDetails] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [NavigateTo] = useCustomNavigate();
  const [columns, setColumns] = useState<any>();
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    getTableColumns();
    getAppliedJobsTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const getTableColumns = () => {
    if (user && user?.role === "localagents") {
      let columns = [
        { label: "Jobs", key: "jobs" },
        { label: "Applicants", key: "applicants" },
        { label: "Shortlisted", key: "shortlisted" },
        { label: "Rejected", key: "rejected" },
        { label: "Hired", key: "hired" },
        { label: "View Applicant", key: "view_applicant" },
        { label: "Actions", key: "actions" },
      ];
      setColumns(columns);
    } else if (user && user?.role === "jobseeker") {
      let columns = [
        { label: "Job ID", key: "id" },
        { label: "Job Title", key: "title" },
        { label: "Company Name", key: "company_name" },
        { label: "Department", key: "department" },
        { label: "Applied Date", key: "applied_date" },
        { label: "Status", key: "status" },
        { label: "Actions", key: "actions" },
      ];

      setColumns(columns);
    }
  };

  const handleView = async (row: any) => {
    handleShow();
    try {
      setIsModalLoading(true);
      const response = await appliedJobDetails(row?._id);
      setAppliedJobDetails(response?.application);
    } catch (err: any) {
      showError(err?.message);
    } finally {
      setIsModalLoading(false);
    }
  };

  const handleViewApplicants = async (row: any) => {
    NavigateTo(AppRoute.AGENT_APPLICATIONS, false, { jobId: row?.jobID?._id });
  };

  const handleDelete = async (row: any) => {
    
    Alert.confirm("Are you sure?", "You want to delete this applied job").then(
      async (resp) => {
        if (resp) {
          try {
            await appliedJobDelete(row._id);
            getAppliedJobsTableData();
          } catch (err: any) {
            showError(err?.message);
          } finally {
            // setLoading(false);
          }
        }
      }
    );
  };

  const getAppliedJobsTableData = async (
    page = 1,
    search = "",
    sortKey = "",
    sortDirection = "",
    itemsPerPage = 5
  ) => {
    try {
      setIsLoading(true);
      let transformed: any = [];
      const response = await appliedJobList(
        page,
        search,
        sortKey,
        sortDirection,
        itemsPerPage
      );
      if (user && user?.role === "jobseeker") {
        transformed = await transformedData(
          response?.applications?.applications
        );
      } else if (user && user?.role === "localagents") {
        transformed = await transformedDataForLocalAgent(
          response?.applications?.applications
        );
      }
      setAppliedJobsTableData(transformed);
      setTotalPages(response?.applications?.totalPages);
      setCurrentPage(Number(response?.applications?.page));
    } catch (err: any) {
      showError(err?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const transformedData = async (applicants: any = []) => {
    return (
      applicants &&
      applicants?.map((app: any, index: number) => {
        const baseData: any = {
          id: index + 1,
          title: app.jobID.title,
          company_name: app?.jobID?.userID?.externalInfo?.name || "N/A",
          department: app?.jobID?.category?.categoryName || "N/A",
          applied_date: new Date(app.createdAt).toLocaleDateString(),
          status: app?.status ? _.startCase(_.toLower(app?.status)) : "N/A",
          actions: (
            <div>
              <button
                className="btnnoStyle btn btn-primary"
                onClick={() => handleView(app)}
                style={{ marginRight: "10px" }}
              >
                <LuEye />
              </button>
              <button
                className="btnnoStyle red btn btn-primary"
                onClick={() => handleDelete(app)}
                style={{ marginRight: "10px" }}
              >
                <AiOutlineDelete />
              </button>
            </div>
          ),
        };

        return baseData;
      })
    );
  };

  const transformedDataForLocalAgent = async (applicants: any = []) => {
    return (
      applicants &&
      applicants.map((app: any, index: number) => ({
        jobs: (
          <>
            <div className="profileholdertable d-flex">
              <h4>{app?.jobID?.title || "N/A"}</h4>
            </div>
            <p className="postdate">
              Created on :{" "}
              {app?.jobID?.createdAt
                ? moment(app?.jobID?.createdAt).format("DD MMM YYYY")
                : "N/A"}{" "}
              <span>
                Expires on :{" "}
                {app?.jobID?.deadlineDate
                  ? moment(app?.jobID?.deadlineDate).format("DD MMM YYYY")
                  : "N/A"}
              </span>
            </p>
          </>
        ),

        applicants: app?.jobSummary?.applied || 0,
        shortlisted: app?.jobSummary?.shortlisted || 0,
        rejected: app?.jobSummary?.rejected || 0,
        hired: app?.jobSummary?.hired || 0,
        view_applicant: (
          <div>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              className={"moreview "+(app?.applicationsSummary?.applied>0?``:`disabled`)}
              onClick={() => app?.jobSummary?.applied > 0 && handleViewApplicants(app)}
              style={app?.jobSummary?.applied > 0 ? { cursor: "pointer", textDecoration: "underline" }:undefined}
            >
              View Applicates
            </a>
          </div>
        ),
        actions: (
          <div>
            <button
              className="btnnoStyle btn btn-primary"
              onClick={() => handleView(app)}
              style={{ marginRight: "10px" }}
            >
              <LuEye />
            </button>
            {/* <button
              className="btn btn-danger"
              onClick={() => handleDelete(app)}
              style={{ marginRight: "10px" }}
            >
              <AiOutlineDelete />
            </button> */}
          </div>
        ),
      }))
    );
  };
  const handlePageChange = (page: number) => {
    getAppliedJobsTableData(page);
  };

  const handleSearch = (searchTerm: string) => {
    getAppliedJobsTableData(1, searchTerm); // Reset to the first page when searching
  };

  const handleSort = (key: string, direction: string) => {
    getAppliedJobsTableData(1, "", key, direction); // Reset to the first page when sorting
  };

  const handleItemsPerPageChange = (itemsPerPage: number) => {
    getAppliedJobsTableData(1, "", "", "", itemsPerPage); // Reset to the first page when items per page changes
  };

  return (
    <>
      <div className="main">
        <section className="profileJoblisting-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar  position-relative p-0">
                {user && user?.role === "jobseeker" && <SidebarScreen />}
                {user && user?.role === "localagents" && <AgentSidebarScreen />}
              </div>
              <div className="col-lg-10 rightcontent p-0">
                {user && user?.role === "jobseeker" && <TopHeadScreen />}
                {user && user?.role === "localagents" && <AgentTopHeadScreen />}
                <div className="profileJoblisting-holder rightInnerScroll">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="applied-title">
                        <div className="title">
                          <h2>Applied Jobs</h2>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* DATA TABLE */}
                  {isLoading ? (
                    <Loader />
                  ) : (
                    columns &&
                    columns.length > 0 && (
                      <DataTable
                        data={appliedJobsTableData}
                        columns={columns}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                        currentPage={currentPage}
                        onSearch={handleSearch}
                        onSort={handleSort}
                        onItemsPerPageChange={handleItemsPerPageChange}
                      />
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <AuthFooterScreen />

      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="findajobmodal"
        centered
      >
        
        <button
          type="button"
          className="btn-close custom-close-btn"
          onClick={handleClose}
          aria-label="Close"
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            zIndex: 9,

            border: "none",
            fontSize: "1rem",
            cursor: "pointer",
          }}
        ></button>
        <Modal.Body>
          {isModalLoading ? (
                    <Loader />
                  ) : 
            jobDetails && (
              <div className="afterapplied">
                <h3>{jobDetails?.application?.jobID?.title || ""}</h3>
                <div className="aplyinfo">
                  <h4>
                    <strong>Job Title:</strong>{" "}
                    {jobDetails?.application?.jobID?.title || "N/A"}
                  </h4>
                  <h4>
                    <strong>Company Name:</strong>{" "}
                    {jobDetails?.employer?.externalInfo?.name || "N/A"}
                  </h4>
                  <h4>
                    <strong>Location:</strong>{" "}
                    {jobDetails?.application?.jobID?.location || "N/A"}
                  </h4>
                  <h4>
                    <strong>Application Date:</strong>{" "}
                    {jobDetails?.application?.createdAt
                      ? moment(jobDetails?.application?.createdAt).format(
                          "MMM DD, YYYY"
                        )
                      : "N/A"}
                  </h4>
                  <h4>
                    <strong>Job Type 1:</strong>{" "}
                    {jobDetails?.application?.jobID?.type?.typeName || "N/A"}
                  </h4>
                  <h4>
                    <strong>Status:</strong>{" "}
                    {jobDetails?.application?.status.toUpperCase() || "N/A"}
                  </h4>
                  <h4>
                    <strong>Salary Range:</strong> $
                    {jobDetails?.application?.jobID?.salaryMin} - $
                    {jobDetails?.application?.jobID?.salaryMax}/month
                  </h4>
                </div>
              </div>
            )
          }
        </Modal.Body>
      </Modal>
    </>
  );
};
export default AppliedJobScreen;
